import { apiRoot } from '../apiInstances';
export type EntityKey = 'estimates' | 'work-orders' | 'invoices';

export const feesApi = {
  list: async (entity: EntityKey, parentId: number) => {
    const { data } = await apiRoot.get(`/${entity}/${parentId}/fees`);
    return data as any[];
  },
  add: async (entity: EntityKey, parentId: number, body: any) => {
    const { data } = await apiRoot.post(`/${entity}/${parentId}/fees`, body);
    return data;
  },
  update: async (entity: EntityKey, parentId: number, feeId: number, body: any) => {
    const { data } = await apiRoot.put(`/${entity}/${parentId}/fees/${feeId}`, body);
    return data;
  },
  remove: async (entity: EntityKey, parentId: number, feeId: number) => {
    await apiRoot.delete(`/${entity}/${parentId}/fees/${feeId}`);
  },
  listTemplates: async () => {
    const { data } = await apiRoot.get('/shop-settings/fee-templates');
    return data as any[];
  },
};
